export const INDEX_FOLLOW_ROBOTS = "index,follow";
export const NOINDEX_FOLLOW_ROBOTS = "noindex,follow";
